var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper',{attrs:{"options":{
    placement: _vm.placement,
    modifiers: { offset: { offset: _vm.offset } },
  }}},[_c('div',{staticClass:"popper dashboard-card-tooltip"},[_vm._t("default")],2),_c('div',{staticClass:"d-flex pointer",attrs:{"slot":"reference"},slot:"reference"},[_c('icons-question',{attrs:{"width":19,"height":19,"color":"#95979D"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }